import gql from 'graphql-tag'

const brandMarquee = gql`query GetBrandMarquee {
  brandMarqueeLogo {
    logoImage {
      urls
    }
    altText
    linkURL
  }
}`

interface brandMarqueeObj {
  logoImage: string,
  altText: string,
}

export {
  brandMarquee,
  brandMarqueeObj
}